import React from 'react';
import { connect } from 'react-redux';
import style from './index.scss';
import moment from 'moment';
import { Layout, PageHeader, Space, Table } from 'antd';
import { fetchTypologies } from '../../../redux/actions/trm/trmDashboard';
import { dateTimeFormat } from '../../../util/GlobalConstant';
import { CustomHeader } from '../components/CustomHeaderComponent/customHeader';
import {
  AddToBucketComponent,
  DeleteComponent,
  NotesComponent,
  TextComponent,
  TitleComponent
} from '../components/TableComponents';

const { Header, Content, Footer } = Layout;

/**
 * MoveToProductionClass Class
 */
class MoveToProductionClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddGroupModalShown: false,
      groups: [],
      trmTypologies: [],
      defaultCurrent: 1,
      pageSize: 20,
      showScenarioModal: false,
      selectedTypology: ''
    };
    this.drawerRef = React.createRef();
    this.columns = [
      {
        title: '',
        className: style.bgWhite,
        width: '10%',
        render: (typology) => (
          <AddToBucketComponent
            {...typology}
            onAddTypologyToScenario={this.onAddTypologyToScenario}
          />
        )
      },
      {
        title: <CustomHeader title={'Typology ID'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '10%',
        render: (typology) => (
          <TextComponent style={{ color: '#0C8ED7' }} id={typology.id} />
        )
      },
      {
        title: <CustomHeader title={'Typology Name'} />,
        dataIndex: 'typology',
        width: '35%',
        className: style.bgWhite,
        key: 'typology',
        onCell: (record, rowIndex) => {
          return {
            onClick: (event) => {
              if (event.target instanceof HTMLImageElement) {
                this.onDrawerOpen(2);
              } else {
                this.onDrawerOpen(0);
              }
            }
          };
        },
        render: (typology) => <TitleComponent title={typology.title} />
      },
      {
        title: <CustomHeader title={'Notes'} />,
        dataIndex: 'notes',
        width: '10%',
        className: style.bgWhite,
        key: 'notes',
        render: (notes) => <NotesComponent notes={notes} />
      },
      {
        title: <CustomHeader title={'Creator'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '10%',
        render: (typology) => <TextComponent id={typology.createdBy} />
      },
      {
        title: <CustomHeader title={'Scenarios'} />,
        dataIndex: 'scenarios',
        className: style.bgWhite,
        key: 'scenarios',
        width: '10%',
        render: (scenarios) => (
          <TextComponent style={{ fontWeight: 'bold' }} id={scenarios} />
        )
      },
      {
        title: <CustomHeader title={'Last Update'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '15%',
        render: (typology) => (
          <TextComponent
            id={moment
              .utc(typology.updatedTime, [dateTimeFormat])
              .format('DD-MMM-YYYY,HH:mm')}
          />
        )
      },
      {
        title: '',
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        render: (typology) => <DeleteComponent />
      }
    ];
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.fetchTypologiesData({
      page: this.state.defaultCurrent - 1,
      pageSize: this.state.pageSize
    });
  }

  onAddTypologyToScenario = (typologyObject) => {
    this.setState({
      showScenarioModal: !this.state.showScenarioModal,
      selectedTypology: typologyObject
    });
  };

  /**
   * getDerivedStateFromProps
   * @param nextProps
   * @returns {null|{trmTypologies: ([]|*[]|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data, error: null}|*)}}
   */
  static getDerivedStateFromProps(nextProps) {
    const { trmDashboard } = nextProps;

    if (trmDashboard && trmDashboard.trmTypologies) {
      return {
        trmTypologies: trmDashboard.trmTypologies
      };
    }
    return null;
  }

  /**
   * onDrawerOpen
   * @param defaultTab
   */
  onDrawerOpen = (defaultTab = 0) => {
    this.drawerRef.current.showDrawer(defaultTab);
  };

  onPaginationChange = (page, pageSize) => {
    this.setState({ defaultCurrent: page, pageSize });
    this.props.fetchTypologiesData({
      page: page - 1,
      pageSize
    });
  };

  render() {
    const { trmTypologies, defaultCurrent, pageSize } = this.state;
    const { isLoading = true, data = null } = trmTypologies || {};
    let typologyList = [];
    let typologyCount = 0;
    if (!isLoading && data) {
      typologyList = data.typologies;
      typologyCount = data.totalCount;
    }

    return (
      <Layout className="layout">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Deploy In Production"></PageHeader>

        <Content>
          <Space
            size={5}
            direction="vertical"
            style={{ width: '100%', backgroundColor: '#BEC3CA' }}>
            <Content className={style.site_layout_background}>
              <Table
                loading={isLoading}
                columns={this.columns}
                pagination={{
                  total: typologyCount,
                  defaultCurrent: defaultCurrent,
                  onChange: this.onPaginationChange,
                  pageSize
                }}
                rowClassName={style.tableRowClass}
                dataSource={typologyList}
              />
            </Content>
          </Space>
        </Content>
      </Layout>
    );
  }
}

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: trmDashboard}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchTypologiesData: (payload) => {
      dispatch(fetchTypologies(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoveToProductionClass);
